import { useEffect, useRef } from 'react';

/**
 * Calls `callback` after `delay` ms whenever any value in `deps` changes.
 * Resets the timer on every change so rapid typing only fires once.
 */
const useDebounce = (callback: () => void, delay: number, deps: unknown[]) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const callbackRef = useRef(callback);

  // Keep callback ref fresh without re-triggering the effect
  callbackRef.current = callback;

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useDebounce;
